import {
  GET_VERIFY_BEGIN,
  GET_VERIFY_SUCCESS,
  GET_VERIFY_FAIL
} from '../action/verifyemailAction'

const initialState = {
  loading: false,
  verifyemails: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VERIFY_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_VERIFY_SUCCESS:
      return {
        loading: false,
        verifyemails: action.payload.data
      }
    case GET_VERIFY_FAIL:
      return {
        loading: false,
        error: action.payload.error.response.data
      }
    default:
      return state
  }
}